import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SharedSideNav from 'pricing-pages-ui-components/components/layout/side-nav/SideNav';
import { prefetchPage } from '../../../routes/loadablePages';
import { useIsInAppAuth } from '../../../v2/hooks/user/useUserInfo';
import { usePreserveQueryParams } from '../../../v2/hooks/utilities/usePreserveQueryParams';
import CurrencyPicker from '../../common/CurrencyPicker';
import { useSideNavItems } from './useSideNavItems';
import { jsx as _jsx } from "react/jsx-runtime";
const SideNav = ({
  selectedNavItem
}) => {
  const createToWithQueryParams = usePreserveQueryParams();
  const {
    visibleSections,
    visibleItemsBySection
  } = useSideNavItems();
  const isInAppAuth = useIsInAppAuth();
  const sections = visibleSections.map(navSection => ({
    section: navSection,
    headingText: I18n.text(`pricingPage.sidenav.sections.${navSection}`),
    items: visibleItemsBySection[navSection].map(navItem => ({
      navItem,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricingPage.pages.products.tabs.${navItem}.tabTitle`
      }),
      to: createToWithQueryParams(`/${navItem}`),
      onMouseEnter: () => prefetchPage(navItem)
    }))
  }));
  return /*#__PURE__*/_jsx(SharedSideNav, {
    selectedNavItem: selectedNavItem,
    selectedItemLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `pricingPage.pages.products.tabs.${selectedNavItem}.tabTitle`
    }),
    menuAriaLabel: I18n.text('pricingPage.sidenav.toggleMenu'),
    sections: sections,
    footerSlot: /*#__PURE__*/_jsx(CurrencyPicker, {}),
    desktopPosition: isInAppAuth ? 'fixed' : 'sticky',
    trackGlobalNavHeight: !isInAppAuth
  });
};
export default SideNav;